import '../../Styles/OutilsTest/general.css';
import {useLang} from '../../../../_metronic/i18n/Metronici18n';

const QosFr = () => (
  <div className="outile-container">
    <h2 className="page-title">Mesure de la Qualité de Service avec ping</h2>

    <section className="section">
      <h3>Introduction</h3>
      <p>
        La qualité de service ou quality of service (QoS) est la capacité à faire transiter des données dans les meilleures conditions possibles en terme de débit, délais de transmission, disponibilité, taux de paquets perdus. C'est un concept de gestion qui a pour but d'optimiser les ressources d'un réseau informatique afin de garantir de bonnes performances aux applications critiques telles que la téléphonie sur IP, la vidéo.
      </p>

      <h3>Classes QoS</h3>
      <p>La qualité de service chez CELESTE est basée sur DSCP (Differentiated Services Code Point) et comporte six classes :</p>
      <div className="table-wrapper">
        <table className="styled-table">
          <thead>
            <tr>
              <th>Classe</th>
              <th>Nom</th>
              <th>ToS</th>
              <th>% BP garantie</th>
              <th>Priorité</th>
              <th>Type de trafic</th>
            </tr>
          </thead>
          <tbody>
            <tr><td><b>EF</b></td><td>Express Forwarding</td><td>0xb8</td><td>10</td><td>1</td><td>Téléphonie</td></tr>
            <tr><td><b>LEF</b></td><td>Less than Express</td><td>0x88</td><td>10</td><td>2</td><td>Vision-conférence, flux DNS</td></tr>
            <tr><td><b>IF</b></td><td>Instant Forwarding</td><td>0x68</td><td>12</td><td>3</td><td>Citrix, TSE, SSH</td></tr>
            <tr><td><b>BBE</b></td><td>Best than Best Effort</td><td>0x48</td><td>25</td><td>4</td><td>Web, monitoring</td></tr>
            <tr><td><b>BE</b></td><td>Best Effort</td><td>0x00</td><td>20</td><td>5</td><td>tous les flux hors ceux cités dans les autres classes</td></tr>
            <tr><td><b>LBE</b></td><td>Less than Best Effort</td><td>0x28</td><td>20</td><td>6</td><td>Trafic lourd (FTP, mails)</td></tr>
          </tbody>
        </table>
      </div>

      <h3>Installation</h3>
      <p>Afin de tester un réseau comportant de la QoS, nous allons voir comment générer des flux de priorités différentes.</p>
      <h4>Sous Windows</h4>
      <ul style={{listStyleType: 'circle', marginLeft: '20px'}}>
        <li>Télécharger le fichier <a href="/hrping.zip">hrping.zip</a>.</li>
        <li>Extraire ce fichier dans un dossier.</li>
        <li>Ouvrir un terminal (exécuter, taper "cmd").</li>
        <li>Se rendre dans le dossier ou hrping.zip a été extrait.</li>
      </ul>
      <h4>Sous Linux</h4>
      <p>Aucun prérequis : en natif, linux a déjà les outils de test.</p>

      <h3>Utilisation</h3>
      <p>
        Cette commande permet d'envoyer des paquets ICMP. En jouant avec les paramètres de la commande, il est possible de générer un trafic plus ou moins important (en terme de bande passante) ainsi que de modifier la classe QoS des paquets envoyés. Sous Windows, ceci est rendu possible grâce à l'utilisation de Hrping.
      </p>
      <h4>Sous Windows</h4>
      <div className="command-block">
        <div className="command-title">Commande : HrPING iperf1.celeste.fr -t -s [ms] -L [octets] -v [ToS]</div>
        <pre className="code-block">{`Définition des paramètres :
t : Permet d'envoyer des pings en continu.
s : Intervalle de temps entre chaque ping envoyé en millisecondes.
L :  Taille des paquets envoyés.
v : Marquage QoS des paquets envoyés.`}</pre>
      </div>

      <h4>Sous Linux</h4>
      <div className="command-block">
        <div className="command-title">Commande : ping iperf1.celeste.fr -i [secondes] -s [octets] -Q [ToS]</div>
        <pre className="code-block">{`Définition des paramètres :
i : Intervalle de temps entre chaque ping envoyé en secondes.
s : Taille des paquets envoyés.
Q : Marquage QoS des paquets envoyés.`}</pre>
      </div>

      <h4>Paramètres</h4>
      <p>Le tableau ci-dessous donne les valeurs à entrer en fonction de la bande passante à générer. Faire attention à l'unité de l'intervalle de temps qui est ici en millisecondes.</p>
      <div className="table-wrapper">
        <table className="styled-table">
          <thead>
            <tr>
              <th>Taille des paquets (Octets)</th>
              <th>Intervalle de temps (ms)</th>
              <th>BP générée (Kbit/s)</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>1200</td><td>100</td><td>100</td></tr>
            <tr><td>2500</td><td>100</td><td>200</td></tr>
            <tr><td>2500</td><td>40</td><td>500</td></tr>
            <tr><td>1200</td><td>10</td><td>1000</td></tr>
            <tr><td>2500</td><td>10</td><td>2000</td></tr>
            <tr><td>2500</td><td>4</td><td>5000</td></tr>
            <tr><td>2000</td><td>0.1</td><td>10000</td></tr>
            <tr><td>15000</td><td>0.1</td><td>50000</td></tr>
            <tr><td>50000</td><td>0.1</td><td>100000</td></tr>
          </tbody>
        </table>
      </div>

      <h3>Utilisation</h3>
      <h4>Exemple</h4>
      <div className="command-block">
        <div className="command-title">Commande : hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0xb8</div>
        <pre className="code-block">{`Pinging iperf1.celeste.fr [178.16.168.33]
with 1172 bytes data (1200 bytes UP), TOS 184 (0xb8), IP_HDRINCL:

From 178.16.168.33: bytes=1200 seq=0001 TTL=59 ID=3234 time=1.039ms
From 178.16.168.33: bytes=1200 seq=0002 TTL=59 ID=3235 time=0.839ms
From 178.16.168.33: bytes=1200 seq=0003 TTL=59 ID=3236 time=0.907ms
From 178.16.168.33: bytes=1200 seq=0004 TTL=59 ID=3237 time=1.380ms`}</pre>
      </div>

      <p>Le champ « time » est le temps qu'il a fallu au ping pour faire l'aller-retour entre la machine hôte et la machine de destination (iperf1.celeste.fr).</p>
      <p>
        Ce premier test permet de vérifier que la QoS est appliquée au lien. Il s'agit de générer un trafic total inférieur à la bande passante du lien de sorte à faire apparaître sur le graphique de l'espace client la totalité du trafic généré. Les commandes qui suivent génèrent chacune 1 Mbit/s de trafic sur chaque classe (un terminal doit être utilisé par classe). Les valeurs sont à adapter en fonction de la bande passante du lien (10% de bande passante par classe). Afin d'observer une période entière, tester le lien pendant au moins 10 minutes. L'exemple suivant est pour un lien de 10Mbit/s ou plus.
      </p>

      <h4>Par classe</h4>
      <table className="styled-table" style={{width: '100%'}}>
        <thead><tr><th>Classe</th><th>Windows</th><th>Linux</th></tr></thead>
        <tbody>
          <tr><td>EF</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0xb8</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0xb8</span></td></tr>
          <tr><td>BE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x00</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x00</span></td></tr>
          <tr><td>LEF</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x88</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x88</span></td></tr>
          <tr><td>IF</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x68</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x68</span></td></tr>
          <tr><td>BBE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x48</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x48</span></td></tr>
          <tr><td>LBE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x28</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x28</span></td></tr>
        </tbody>
      </table>
      <br/>

      <h4>En application :</h4>
      <p>Génération d'un trafic avec un marquage EF aussi important que la bande passante du lien :</p>
      <table className="styled-table" style={{width: '100%'}}>
        <thead><tr><th>Classe</th><th>Windows</th><th>Linux</th></tr></thead>
        <tbody>
          <tr><td>EF</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 0.1 -L 2000 -v 0xb8</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.0001 -s 2000 -Q 0xb8</span></td></tr>
        </tbody>
      </table>
      <br/>

      <p>Génération d'un trafic par défaut (20% de bande passante réservée). Générer au minimum 2Mbit/s de trafic pour un lien de 10Mbit/s :</p>
      <table className="styled-table" style={{width: '100%'}}>
        <thead><tr><th>Classe</th><th>Windows</th><th>Linux</th></tr></thead>
        <tbody>
          <tr><td>BE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 2500 -v 0x00</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 2500 -Q 0x00</span></td></tr>
        </tbody>
      </table>
      <br/>

      <p>Génération d'un flux LEF (10% de bande passante réservée). Générer au minimum 1Mbit/s de trafic pour un lien de 10Mbit/s :</p>
      <table className="styled-table" style={{width: '100%'}}>
        <thead><tr><th>Classe</th><th>Windows</th><th>Linux</th></tr></thead>
        <tbody>
          <tr><td>BE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 2500 -v 0x88</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 2500 -Q 0x88</span></td></tr>
        </tbody>
      </table>
      <br/>

      <h3>Contrôle Espace Clients</h3>
      <p>On peut observer le graphique QoS présent dans l'Espace Clients du lien testé. L'ensemble du trafic généré précédemment en fonction des classes de QoS doit apparaître sur celui-ci.</p>
    </section>
  </div>
);

const QosEn = () => (
  <div className="outile-container">
    <h2 className="page-title">Quality of Service measurement with ping</h2>

    <section className="section">
      <h3>Introduction</h3>
      <p>
        Quality of Service (QoS) is the ability to transmit data under the best possible conditions in terms of throughput, transmission delay, availability, and packet loss rate. It is a management concept aimed at optimizing network resources to guarantee good performance for critical applications such as VoIP telephony and video.
      </p>

      <h3>QoS Classes</h3>
      <p>CELESTE's quality of service is based on DSCP (Differentiated Services Code Point) and includes six classes:</p>
      <div className="table-wrapper">
        <table className="styled-table">
          <thead>
            <tr>
              <th>Class</th>
              <th>Name</th>
              <th>ToS</th>
              <th>% guaranteed BW</th>
              <th>Priority</th>
              <th>Traffic type</th>
            </tr>
          </thead>
          <tbody>
            <tr><td><b>EF</b></td><td>Express Forwarding</td><td>0xb8</td><td>10</td><td>1</td><td>Telephony</td></tr>
            <tr><td><b>LEF</b></td><td>Less than Express</td><td>0x88</td><td>10</td><td>2</td><td>Video conferencing, DNS traffic</td></tr>
            <tr><td><b>IF</b></td><td>Instant Forwarding</td><td>0x68</td><td>12</td><td>3</td><td>Citrix, TSE, SSH</td></tr>
            <tr><td><b>BBE</b></td><td>Best than Best Effort</td><td>0x48</td><td>25</td><td>4</td><td>Web, monitoring</td></tr>
            <tr><td><b>BE</b></td><td>Best Effort</td><td>0x00</td><td>20</td><td>5</td><td>all traffic not listed in other classes</td></tr>
            <tr><td><b>LBE</b></td><td>Less than Best Effort</td><td>0x28</td><td>20</td><td>6</td><td>Heavy traffic (FTP, email)</td></tr>
          </tbody>
        </table>
      </div>

      <h3>Installation</h3>
      <p>To test a network with QoS, we will see how to generate traffic with different priorities.</p>
      <h4>Under Windows</h4>
      <ul style={{listStyleType: 'circle', marginLeft: '20px'}}>
        <li>Download the file <a href="/hrping.zip">hrping.zip</a>.</li>
        <li>Extract the file to a folder.</li>
        <li>Open a terminal (run, type "cmd").</li>
        <li>Navigate to the folder where hrping.zip was extracted.</li>
      </ul>
      <h4>Under Linux</h4>
      <p>No prerequisites: Linux natively includes the testing tools.</p>

      <h3>Usage</h3>
      <p>
        This command sends ICMP packets. By adjusting the command parameters, you can generate more or less traffic (in terms of bandwidth) and modify the QoS class of the sent packets. Under Windows, this is made possible by using Hrping.
      </p>
      <h4>Under Windows</h4>
      <div className="command-block">
        <div className="command-title">Command: HrPING iperf1.celeste.fr -t -s [ms] -L [bytes] -v [ToS]</div>
        <pre className="code-block">{`Parameter definitions:
t: Sends pings continuously.
s: Time interval between each ping sent, in milliseconds.
L: Size of packets sent.
v: QoS marking of packets sent.`}</pre>
      </div>

      <h4>Under Linux</h4>
      <div className="command-block">
        <div className="command-title">Command: ping iperf1.celeste.fr -i [seconds] -s [bytes] -Q [ToS]</div>
        <pre className="code-block">{`Parameter definitions:
i: Time interval between each ping sent, in seconds.
s: Size of packets sent.
Q: QoS marking of packets sent.`}</pre>
      </div>

      <h4>Parameters</h4>
      <p>The table below gives the values to enter based on the bandwidth to generate. Note that the time interval unit here is milliseconds.</p>
      <div className="table-wrapper">
        <table className="styled-table">
          <thead>
            <tr>
              <th>Packet size (Bytes)</th>
              <th>Time interval (ms)</th>
              <th>Generated BW (Kbit/s)</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>1200</td><td>100</td><td>100</td></tr>
            <tr><td>2500</td><td>100</td><td>200</td></tr>
            <tr><td>2500</td><td>40</td><td>500</td></tr>
            <tr><td>1200</td><td>10</td><td>1000</td></tr>
            <tr><td>2500</td><td>10</td><td>2000</td></tr>
            <tr><td>2500</td><td>4</td><td>5000</td></tr>
            <tr><td>2000</td><td>0.1</td><td>10000</td></tr>
            <tr><td>15000</td><td>0.1</td><td>50000</td></tr>
            <tr><td>50000</td><td>0.1</td><td>100000</td></tr>
          </tbody>
        </table>
      </div>

      <h3>Usage</h3>
      <h4>Example</h4>
      <div className="command-block">
        <div className="command-title">Command: hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0xb8</div>
        <pre className="code-block">{`Pinging iperf1.celeste.fr [178.16.168.33]
with 1172 bytes data (1200 bytes UP), TOS 184 (0xb8), IP_HDRINCL:

From 178.16.168.33: bytes=1200 seq=0001 TTL=59 ID=3234 time=1.039ms
From 178.16.168.33: bytes=1200 seq=0002 TTL=59 ID=3235 time=0.839ms
From 178.16.168.33: bytes=1200 seq=0003 TTL=59 ID=3236 time=0.907ms
From 178.16.168.33: bytes=1200 seq=0004 TTL=59 ID=3237 time=1.380ms`}</pre>
      </div>

      <p>The "time" field is the round-trip time for the ping between the host machine and the destination (iperf1.celeste.fr).</p>
      <p>
        This first test verifies that QoS is applied to the link. The goal is to generate total traffic below the link's bandwidth so that all generated traffic appears on the customer portal graph. The following commands each generate 1 Mbit/s of traffic per class (one terminal per class). Values should be adjusted based on the link's bandwidth (10% per class). To observe a full period, run the test for at least 10 minutes. The following example applies to a 10 Mbit/s or higher link.
      </p>

      <h4>Per class</h4>
      <table className="styled-table" style={{width: '100%'}}>
        <thead><tr><th>Class</th><th>Windows</th><th>Linux</th></tr></thead>
        <tbody>
          <tr><td>EF</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0xb8</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0xb8</span></td></tr>
          <tr><td>BE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x00</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x00</span></td></tr>
          <tr><td>LEF</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x88</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x88</span></td></tr>
          <tr><td>IF</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x68</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x68</span></td></tr>
          <tr><td>BBE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x48</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x48</span></td></tr>
          <tr><td>LBE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 1200 -v 0x28</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 1200 -Q 0x28</span></td></tr>
        </tbody>
      </table>
      <br/>

      <h4>In practice:</h4>
      <p>Generating traffic with EF marking as large as the link's bandwidth:</p>
      <table className="styled-table" style={{width: '100%'}}>
        <thead><tr><th>Class</th><th>Windows</th><th>Linux</th></tr></thead>
        <tbody>
          <tr><td>EF</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 0.1 -L 2000 -v 0xb8</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.0001 -s 2000 -Q 0xb8</span></td></tr>
        </tbody>
      </table>
      <br/>

      <p>Generating default traffic (20% reserved bandwidth). Generate at least 2 Mbit/s for a 10 Mbit/s link:</p>
      <table className="styled-table" style={{width: '100%'}}>
        <thead><tr><th>Class</th><th>Windows</th><th>Linux</th></tr></thead>
        <tbody>
          <tr><td>BE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 2500 -v 0x00</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 2500 -Q 0x00</span></td></tr>
        </tbody>
      </table>
      <br/>

      <p>Generating LEF traffic (10% reserved bandwidth). Generate at least 1 Mbit/s for a 10 Mbit/s link:</p>
      <table className="styled-table" style={{width: '100%'}}>
        <thead><tr><th>Class</th><th>Windows</th><th>Linux</th></tr></thead>
        <tbody>
          <tr><td>BE</td><td><span className="command-title">hrPING iperf1.celeste.fr -t -s 10 -L 2500 -v 0x88</span></td><td><span className="command-title">ping iperf1.celeste.fr -i 0.01 -s 2500 -Q 0x88</span></td></tr>
        </tbody>
      </table>
      <br/>

      <h3>Customer Portal verification</h3>
      <p>You can observe the QoS graph in the Customer Portal for the tested link. All traffic generated above, broken down by QoS class, should appear on it.</p>
    </section>
  </div>
);

const Qos = () => {
  const lang = useLang();
  return lang === 'en' ? <QosEn /> : <QosFr />;
};

export default Qos;
